export default __webpack_public_path__ + "static/Daniel-15ada9d2ed5902dbc11c83f31cb32551.jpeg";